interface CampaignTypeFilterProps {
  campaignType: string;
  onCampaignTypeChange: (type: string) => void;
  disabled?: boolean;
}

const CAMPAIGN_TYPES = [
  { value: '', label: 'All Types' },
  { value: 'SEARCH', label: 'Search' },
  { value: 'DISPLAY', label: 'Display' },
  { value: 'SHOPPING', label: 'Shopping' },
  { value: 'VIDEO', label: 'Video' },
  { value: 'PERFORMANCE_MAX', label: 'Performance Max' },
];

export default function CampaignTypeFilter({ campaignType, onCampaignTypeChange, disabled }: CampaignTypeFilterProps) {
  return (
    <select
      className="command-bar-select"
      value={campaignType}
      onChange={(e) => onCampaignTypeChange(e.target.value)}
      disabled={disabled}
      title="Campaign type"
    >
      {CAMPAIGN_TYPES.map((t) => (
        <option key={t.value} value={t.value}>{t.label}</option>
      ))}
    </select>
  );
}
